/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IConvexDeposits,
  IConvexDepositsInterface,
} from "../IConvexDeposits";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_pid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_stake",
        type: "bool",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "_lock",
        type: "bool",
      },
      {
        internalType: "address",
        name: "_stakeAddress",
        type: "address",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IConvexDeposits__factory {
  static readonly abi = _abi;
  static createInterface(): IConvexDepositsInterface {
    return new utils.Interface(_abi) as IConvexDepositsInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IConvexDeposits {
    return new Contract(address, _abi, signerOrProvider) as IConvexDeposits;
  }
}
